// extracted by mini-css-extract-plugin
module.exports = {"flex":"style__flex__NHNMM","modalFooter":"style__modalFooter__0GbpO"};